import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.714 5.291a.833.833 0 0 1 0 1.179l-8.25 8.249a.833.833 0 1 1-1.178-1.178l8.25-8.25a.833.833 0 0 1 1.178 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.289 5.29a.833.833 0 0 1 1.179 0l8.247 8.249a.833.833 0 1 1-1.178 1.178L5.289 6.47a.833.833 0 0 1 0-1.178",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }